// src/guide/selection_tiers/guide_selection_tiers.js
import {
  guide_tour_init,
  guide_tour_step_start,
  guide_tour_step_complete,
} from "@/guide/utils/guide_tour_actions";

export async function guide_selection_tiers(langs) {
  let translations;
  try {
    // Charge dynamiquement le JSON correspondant (ex: guide_traduction_fr.json)
    translations = (
      await import(`@/guide/traductions/guide_traduction_${langs}.json`)
    ).default;
  } catch (error) {
    console.error(
      "Erreur lors du chargement des traductions pour la langue",
      langs,
      error
    );
    return;
  }
  const tour = guide_tour_init();

  guide_tour_step_start(
    tour,
    translations,
    translations.selection_tiers.identifiant.titre,
    translations.selection_tiers.identifiant.texte,
    "#selectEntreprise",
    "bottom"
  );

  guide_tour_step_complete(
    tour,
    translations,
    translations.selection_tiers.rechercher.titre,
    translations.selection_tiers.rechercher.texte,
    "#click",
    "top"
  );

  tour.start();
}
